module.exports = __webpack_public_path__ + "img/faile.2fb082bd.png";